"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRouter = require("react-router");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _pfaHero = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.defaultProps"));
var _pfaHero2 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.propTypes"));
var _pfaHeroBackground = _interopRequireDefault(require("./pfa-hero-background"));
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;
var PFAHero = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(PFAHero, _React$Component);
  function PFAHero() {
    return _React$Component.apply(this, arguments) || this;
  }
  PFAHero.resourceType = function resourceType() {
    return 'PFA_Hero_1_0_0';
  };
  var _proto = PFAHero.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      defaultData = _this$props.defaultData,
      theme = _this$props.theme;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    return /*#__PURE__*/_react["default"].createElement(_pfaHeroBackground["default"], {
      data: componentData,
      theme: theme
    });
  };
  return PFAHero;
}(_react["default"].Component);
PFAHero.displayName = 'PFAHero';
PFAHero.defaultProps = {
  data: _pfaHero["default"],
  defaultData: _pfaHero["default"]
};
var _default = (0, _reactRouter.withRouter)(PFAHero);
exports["default"] = _default;